import { Dropdown, Spinner } from 'react-bootstrap';

import useLocalStore from 'src/store/useLocalStore';

type SitesDropdownProps = {
  handleSiteChange: (siteId: string | undefined) => void;
  isLoadingSites: boolean;
  existingSites: Array<{ siteId: string; siteName: string }>;
  toggleClassName?: string;
};

const SitesDropdown = ({
  isLoadingSites,
  existingSites,
  handleSiteChange,
  toggleClassName,
}: SitesDropdownProps) => {
  const { selectedSiteId, setSelectedSiteId } = useLocalStore();

  return (
    <Dropdown id="sites-dropdown">
      <Dropdown.Toggle
        variant="outline-primary"
        size="sm"
        disabled={isLoadingSites}
        className={toggleClassName}
        id="sites-dropdown-toggle"
      >
        {isLoadingSites ? (
          <Spinner size="sm" className="me-2" />
        ) : selectedSiteId ? (
          existingSites.find((site) => site.siteId === selectedSiteId)?.siteName
        ) : (
          'All Sites'
        )}
      </Dropdown.Toggle>

      <Dropdown.Menu className="overflow-auto" style={{ maxHeight: '48vh' }}>
        {isLoadingSites ? (
          <Dropdown.Item disabled>
            <div className="d-flex align-items-center">Loading sites...</div>
          </Dropdown.Item>
        ) : (
          <>
            <Dropdown.Item
              as="button"
              onClick={(e) => {
                e.preventDefault();
                setSelectedSiteId(undefined);
                handleSiteChange(undefined);
              }}
            >
              All Sites
            </Dropdown.Item>
            {existingSites.map((site) => (
              <Dropdown.Item
                key={site.siteId}
                as="button"
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedSiteId(site.siteId);
                  handleSiteChange(site.siteId);
                }}
              >
                {site.siteName}
              </Dropdown.Item>
            ))}
          </>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default SitesDropdown;
